export default __webpack_public_path__ + "static/media/26-Enchantment.19c90f6c.jpeg";